import React from 'react';
import Routes from './router/Routes'
import FirebaseState from './context/FirebaseState'

function App() {
  return (

    <div className="tokyo_tm_all_wrap">  
      <FirebaseState>
        <Routes/>
      </FirebaseState>
    </div>
    
  );
}

export default App;
